var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9028 4.37402C13.9028 4.49213 13.8609 4.60539 13.7861 4.68891C13.7114 4.77242 13.6101 4.81934 13.5044 4.81934H11.1337L8.21182 14.6162H10.3169C10.4226 14.6162 10.5239 14.6631 10.5986 14.7466C10.6734 14.8302 10.7153 14.9434 10.7153 15.0615C10.7153 15.1796 10.6734 15.2929 10.5986 15.3764C10.5239 15.4599 10.4226 15.5068 10.3169 15.5068H5.00439C4.89872 15.5068 4.79738 15.4599 4.72266 15.3764C4.64794 15.2929 4.60596 15.1796 4.60596 15.0615C4.60596 14.9434 4.64794 14.8302 4.72266 14.7466C4.79738 14.6631 4.89872 14.6162 5.00439 14.6162H7.3751L10.297 4.81934H8.19189C8.08622 4.81934 7.98488 4.77242 7.91016 4.68891C7.83544 4.60539 7.79346 4.49213 7.79346 4.37402C7.79346 4.25592 7.83544 4.14265 7.91016 4.05914C7.98488 3.97563 8.08622 3.92871 8.19189 3.92871H13.5044C13.6101 3.92871 13.7114 3.97563 13.7861 4.05914C13.8609 4.14265 13.9028 4.25592 13.9028 4.37402Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.a4b15af4b906a5b520c0baee48767b62.svg";
export { ForwardRef as ReactComponent };